import { FC } from "react"
import {
  AvailableAndActiveSimCardsDocument,
  SimCardFragment,
} from "@phonero/common-ux"
import { Loading, useAppQuery, useTokenData } from "@phonero/common-ux"
import { ApiProductState, SimCardType2 } from "@phonero/common-graphql/types"
import { SimCardSlides } from "./SimCardSlides"
import { PageContent } from "../../../../components/layout/PageContent"

export const SimCardTypes: FC<{ simCardType: SimCardType2 }> = ({
  simCardType,
}) => {
  const { subscriptionId } = useTokenData()
  const { data, error, loading, refetch } = useAppQuery(
    AvailableAndActiveSimCardsDocument,
    {
      variables: { id: String(subscriptionId) },
    }
  )
  const simCardProduct = data?.mobileSubscription?.simCards?.filter(
    (product) => {
      const simProduct = product as SimCardFragment
      return (
        simProduct.type === simCardType
      )
    }
  ) as SimCardFragment[]

  console.log("subscription sim card for type ", simCardType)
  console.log(simCardProduct)
  return (
    <>
      {!loading ? (
        <PageContent refresh={refetch}>
          <SimCardSlides
            products={simCardProduct}
            editDenied={data?.mobileSubscription?.usageType === "IMPERSONAL"}
          />
        </PageContent>
      ) : (
        <Loading />
      )}
    </>
  )
}
